import LpAnalyticsList from '@/views/lp-analytics/LpAnalyticsList.vue';
import { authSuperAdmin } from '@/common/constants/auth';

export default [
  {
    path: '/lp-analytics',
    name: 'LpAnalyticsList',
    component: LpAnalyticsList,
    meta: authSuperAdmin,
  },
];
